
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { ToastContainer } from "react-toastify";

import { successToaster } from "./../../utils/index";
import apiClient from "../../utils/api";

export const TaxForm = () => {
  let taxDetails = {
    fuel: "",
    gst: "",
  };

  const [taxData, setTaxData] = useState(taxDetails);

  const taxDataHandler = (e) => {
    const taxDataArr = { ...taxData };
    taxDataArr[e.target.name] = e.target.value;
    setTaxData(taxDataArr);
  };

  const taxSubmit = async () => {
    apiClient
      .post(`put/additional_cost.php`, {
        ...taxData,
      })
      .then(() => {
        console.log("success");
        successToaster({ msg: "Tax Added Successful" });
        setTaxData(taxDetails);
      });
  };

  return (
    <>
      <Row className="my-3">
        <h3 className="text-secondary text-uppercase">Tax details</h3>
      </Row>
      <Row className="mb-3">
        <Form.Group as={Col} md="3" controlId="validationCustom01">
          <Form.Label>Fuel Tax(%)</Form.Label>
          <Form.Control
            required
            type="number"
            placeholder="Enter Fuel %"
            name="fuel"
            value={taxData.fuel}
            onChange={(e) => taxDataHandler(e)}
          />
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="validationCustom02">
          <Form.Label>GST Tax(%)</Form.Label>
          <Form.Control
            required
            type="number"
            placeholder="Enter Gst %"
            name="gst"
            value={taxData.gst}
            onChange={(e) => taxDataHandler(e)}
          />
        </Form.Group>
      </Row>
      <Button type="submit" onClick={taxSubmit} className="btn-success">
        Submit Tax Details
      </Button>
      <ToastContainer />
    </>
  );
};
